import type { RootState } from 'src/redux/store';

import { useMemo } from 'react';

import { useAppSelector } from 'src/hook/hooks';

import { PremissionContext } from './permissions-context';

type PermissionProviderProps = {
  children: React.ReactNode;
};

export function PremissionProvider({ children }: PermissionProviderProps) {
  const loginApiData = useAppSelector((state: RootState) => state.auth.loginApiData);

  const getPermissions = () => {
    if (loginApiData && 'permissions' in loginApiData) return loginApiData.permissions;
    // if (loginApiData && 'permissions' in loginApiData)
    //   return {
    //     dashboard: {
    //       view: true,
    //     },
    //     company: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //       import: true,
    //       export: true,
    //     },
    //     contact: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //       import: true,
    //       export: true,
    //     },
    //     inbox: {
    //       view: true,
    //     },
    //     conversation: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //     },
    //     campaign: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //     },
    //     channel: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //     },
    //     user: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //     },
    //     label: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //     },
    //     team: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //     },
    //     template: {
    //       view: true,
    //     },
    //     call: {
    //       view: true,
    //     },
    //     tenants: {
    //       view: true,
    //       list: true,
    //       edit: true,
    //       create: true,
    //       delete: true,
    //     },
    //     ticket: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //     },
    //     organization: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //     },
    //     bill: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //     },
    //     tamplate: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //     },
    //     webhook: {
    //       view: true,
    //       create: true,
    //       edit: true,
    //       delete: true,
    //     },
    //   };

    try {
      const persistRoot = localStorage.getItem('persist:root');
      if (!persistRoot) return null;

      const userPersistData = JSON.parse(persistRoot);
      const authData = JSON.parse(userPersistData?.auth ?? '{}');

      return authData?.loginApiData?.permissions || null;
    } catch (err) {
      console.error('Failed to parse persisted permissions:', err);
      return null;
    }
  };

  const permissions = useMemo(() => getPermissions(), [loginApiData]);

  const handleNavPermissionCheck = (navList: any[]) => {
    if (!permissions) return navList;

    return navList.map((group) => {
      const filteredItems = (group.items || [])
        .map((item: any) => {
          const key = item.id.toLowerCase();

          if (key === 'setting') {
            const visibleChildren = (item.children || []).filter(
              (child: any) => permissions[child.id.toLowerCase()]?.view
            );
            return visibleChildren.length > 0 ? { ...item, children: visibleChildren } : null;
          }
          if (key === 'report') {
            const visibleChildren = (item.children || []).filter(
              (child: any) => permissions[child.id.toLowerCase()]?.view
            );
            return visibleChildren.length > 0 ? { ...item, children: visibleChildren } : null;
          }

          return permissions[key]?.view ? item : null;
        })
        .filter(Boolean);

      return { ...group, items: filteredItems };
    });
  };

  const hasPermission = (module: string): boolean =>
    module === 'setting' ? true : !!permissions?.[module]?.view;

  function hasModuleActionPermission(moduleName: string, actionType: string) {
    const updateModule = moduleName === 'account' ? 'company' : moduleName;
    return permissions?.[updateModule]
      ? permissions?.[updateModule]?.[actionType]
        ? permissions?.[updateModule]?.[actionType] === true
        : false
      : false;
  }

  const contextValue = useMemo(
    () => ({
      handleNavPremissionCheck: handleNavPermissionCheck,
      hasPermission,
      hasModuleActionPermission, // Added to contextValue
    }),
    [permissions]
  );

  return <PremissionContext.Provider value={contextValue}>{children}</PremissionContext.Provider>;
}
